import { addPortNode } from '../port'
import { h } from '@vue/composition-api'

// @ts-ignore
import XSafeKeyboard from '@/components/safe_keyboard/index.vue'

export function showSafeKeyboard(options: {
  type: string
  config: Array<{ key: number; keySlat: number; value: string }>
  onConfirm: (value: any) => any
}) {
  addPortNode(
    h({
      data: () => ({
        visible: false,
      }),

      mounted() {
        // @ts-ignore
        this.visible = true
      },

      render() {
        return h(XSafeKeyboard, {
          props: {
            type: options.type,
            config: options.config,
            value: this.visible,
          },
          on: {
            input: (visible: boolean) => {
              if (!visible) {
                // @ts-ignore
                this.visible = false
              }
            },
            confirm: (value: any) => {
              options.onConfirm(value)
            },
          },
        })
      },
    }),
  )
}
